import { ICellRendererParams } from 'ag-grid-community';
import { Dictionary } from 'lodash';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { HelperText } from 'components/styles';
import { FormInstanceDetails } from 'queries/form-instance';

const ResponsesCount = styled.span`
  ${HelperText};
  padding-left: var(--spacing-02);
`;

type CellRendererParamtypes = {
  instanceDataMap: Dictionary<FormInstanceDetails>;
};

export const FormInstanceName = (
  params: ICellRendererParams & CellRendererParamtypes,
) => {
  const { value, node, instanceDataMap } = params;

  if (!value) {
    return null;
  }

  const instanceData = instanceDataMap
    ? instanceDataMap[parseInt(value, 10)]
    : value;
  const isNoResponseRecorded =
    node.allLeafChildren.length === 1 && !node.allLeafChildren[0].data.answerId;

  return instanceData ? (
    <div>
      {instanceData.taskName}
      {node.allChildrenCount ? (
        <ResponsesCount>
          (
          {isNoResponseRecorded ? (
            <FormattedMessage id="forms.no_response" />
          ) : (
            <FormattedMessage
              id="forms.response.response_count"
              values={{
                count: node.allChildrenCount,
              }}
            />
          )}
          )
        </ResponsesCount>
      ) : null}
    </div>
  ) : null;
};
